module.exports = __webpack_public_path__ + "img/box4.316779e5.jpg";